import React, {useEffect, useState} from 'react';
import {ConfigProvider,message} from "antd";
import zhCN from 'antd/locale/zh_CN';
// for date-picker i18n
import 'dayjs/locale/zh-cn';
import './ConfigApp.css'
import 'antd/dist/reset.css';

//支持react 19
import '@ant-design/v5-patch-for-react-19';
import ConfigRouter from "./ConfigRouter";
import PageLoading from "../components/loading/PageLoading";
import {$getSysByHost} from "../../api/SysApi";
import {saveSys} from "../../utils/Storage";

function ConfigApp() {

    const [sys, setSys] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        saveSys(null);
        $getSysByHost({host:window.location.hostname}).then(res => {
            if(res.status===0){
                if(res.data){
                    setSys(res.data);
                    saveSys(res.data);
                    // 动态设置网站标题
                    if(res.data.name) {
                        document.title = res.data.name;
                    }
                    // 动态设置网站图标
                    if(res.data.icon) {
                        let link = document.querySelector('link[rel*="icon"]');
                        if (!link) {
                            link = document.createElement('link');
                            link.rel = 'icon';
                            document.head.appendChild(link);
                        }
                        link.href = res.data.icon;
                    }
                }
            }else{
                message.error(res.message);
            }
            setLoading(false);
        });
    }, []);



    //在这里全局配置主题样式
    const theme={
        token: {
            colorPrimary: '#1890ff',
            borderRadius: 8,
            colorBgContainer: '#fff',
            // 全局字体颜色
            colorTextBase: '#222',         // 主体文字
            colorTextSecondary: '#666',    // 次要文字
            colorTextLight: '#999',        // 辅助文字
            colorTextLink: '#1890ff',      // 链接色
            // 全局字号
            fontSize: 16,                  // 主字号
            fontSizeHeading1: 24,          // 一级标题
            fontSizeHeading2: 20,          // 二级标题
            fontSizeHeading3: 18,          // 三级标题
            fontSizeSmall: 14,             // 小号字
        },
        components: {
            Button: {
            },
            Input: {
            },
            Card: {
                borderRadius: 12,
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
            },
        },
    };

    if(loading)
        return (<PageLoading/>);

    if(!sys)
        return null;

    return (
        <ConfigProvider locale={zhCN} theme={theme}>
           <ConfigRouter sys={sys}/>
        </ConfigProvider>
    );
}

export default ConfigApp;

